<template>
  <div class="content">
    <div class="row">
      <div class="col-12">
        <card>
          <template slot="header">
            <h4 class="card-title">图纸列表</h4>
          </template>
		  
		  <div>
		  	<button type="button" class="btn btn-primary"  @click="upload()">上传</button>
			<button type="button" class="btn btn-primary"  @click="del()">删除</button>
			<button type="button" class="btn btn-primary"  @click="type()">分类设置</button>
            <button type="button" class="btn btn-primary"  @click="changeType()">分类修改</button>
			<button type="button" class="btn btn-primary"  @click="download()">下载中心</button>
		  </div>
		  
          <div class="table-responsive text-left">
				  <el-table class="table" 
				  :data="files" width="100%"  
				  @current-change="handleCurrenChange"
				  highlight-current-row
				  tooltip-effect="dark"
				  >
				  <el-table-column label="文件名">
					  <template slot-scope="scope">
						<a :href="getLink(scope.row)" target="_blank">
							{{scope.row.name}}
						</a>
					  </template>
				  </el-table-column>
				  <el-table-column prop="uploadTime" label="上传时间"></el-table-column>
				  <el-table-column prop="downloadTimes" label="下载次数"></el-table-column>				  
				  <el-table-column prop="userName" label="操作人"></el-table-column>
				  <el-table-column prop="typeName" label="分类"></el-table-column>
				  <el-table-column prop="note" label="备注"></el-table-column>
			      </el-table>				  
          </div>
		    <div class="block">
		      <el-pagination
		        @size-change="handleSizeChange"
		        @current-change="pageHandleCurrentChange"
		        :current-page="pageParam.currentPage"
		        :page-sizes="[10, 20, 50, 100]"
		        :page-size="10"
		        layout="total, sizes, prev, pager, next, jumper"
		        :total="pageParam.total">
		      </el-pagination>
		    </div>
        </card>

        <Modal :isVisible="showModal" @close="showModal = false">
  		<template #header>
			<div style="color:#000">
			上传图纸
			</div>
		</template>
		<el-select v-model="uploadData.fileTypeId" placeholder="请选择分类">
		  <el-option
		    v-for="item in types"
			clearable
		    :key="item.typeId"
		    :label="item.typeName"
		    :value="item.typeId">
		  </el-option>
		</el-select>
		<el-input v-model="uploadData.note" placeholder="请输入备注"></el-input>
		  <el-upload
			class="upload-demo"
			ref="upload"
			:action="uploadUrl"
			:on-preview="handlePreview"
			:on-remove="handleRemove"
			:on-success="getFiles"
			:file-list="fileList"
			:data="uploadData"
			:drag="true"
			:auto-upload="false">
			<el-button slot="trigger" size="small" type="primary">选取文件</el-button>
			<el-button style="margin-left: 10px;" size="small" type="success" @click="submitUpload">上传到服务器</el-button>
			<div slot="tip" class="el-upload__tip"></div>
		  </el-upload>
			<template #footer>
			</template>
        </Modal>
		
		<Modal :isVisible="showModal2" @close="showModal2 = false">
			<template #header>
				<div style="color:#000">
				图纸分类
				</div>
			</template>			
			<el-tag
			  :key="tag.typeId"
			  style="margin-right: 5px;margin-bottom: 5px;"
			  v-for="tag in types"
			  closable
			  :disable-transitions="false"
			  @close="handleClose(tag)">
			  {{tag.typeName}}
			</el-tag>
			<el-input
			  class="input-new-tag"
			  v-if="inputVisible"
			  v-model="inputValue"
			  ref="saveTagInput"
			  size="small"
			  @keyup.enter.native="handleInputConfirm"
			  @blur="handleInputConfirm"
			>
			</el-input>
			<el-button v-else class="button-new-tag" size="small" @click="showInput">+ New Tag</el-button>
			<template #footer>
				<div></div>
			</template>		
		</Modal>
		
		<Modal :isVisible="showModal3" @close="showModal3 = false">
			<template #header>
				<div style="color:#000">
				图纸分类选择
				</div>
			</template>			
			<el-select v-model="fileTypeId" placeholder="请选择">
			  <el-option
				v-for="item in types"
				clearable
				:key="item.typeId"
				:label="item.typeName"
				:value="item.typeId">
			  </el-option>
			</el-select>
			<template #footer>
				<div>
					<el-button style="margin-left: 10px;" size="small" type="success" @click="submitChangeType">确认</el-button>
				</div>
			</template>		
		</Modal>
		
     </div>
    </div>
  </div>
</template>



<script>
import { Card } from "@/components/index";
import BaseTable from "@/components/BaseTable";
import Modal from "@/pages/Layout/Modal.vue";
import { Checkbox } from "element-ui";
import { Message,MessageBox} from "element-ui";

export default {
  components: {
    Card,
    BaseTable,
	Modal,
  },
  created() {  
      this.getFiles();
  },
  data() {
    return {
	  uploadUrl:this.$serverUrl+"/file/upload",
	  showModal:false,
	  showModal2:false,
	  showModal3:false,
      fileList: [],
	  files:[],
	  fileType:"",
	  fileTypeId:"",
	  pageParam:{
		  pageNum:1,
		  pageSize:10,
		  total:0,
		  currentPage:1,
		  pages:1
	  },
	  currentRow:null,
	  types: [],
	  inputVisible: false,
	  inputValue: '',
	  uploadData:{fileTypeId:"",note:""}
    };
  },
  methods: {
    submitUpload() {
       this.$refs.upload.submit();
    },
    handleRemove(file, fileList) {

    },
    handlePreview(file) {

    },
	upload(){
		this.showModal=true;
		this.get3DType();
	},
	download(){
		 window.open(this.$url+"/#/drawingList", '_blank');
	},
	getFiles(){
		this.$axios.post(this.$serverUrl+"/file/list",this.pageParam).then(
		response => {
		  if(response.status==200){
             this.files=response.data.list;
			 this.pageParam.total=response.data.total;
			 this.pageParam.pages=response.data.pages;
		  }else{
			Message(
			{
			 type: "error",
			 message: response.data.msg,
			 offset:window.screen.height/2-100
			});
		  }
		}
		).catch(
		)
	},
	type(){
		this.types=[];
		this.get3DType();
		this.showModal2=true;
	},
	//列表操作
	handleCurrenChange(val){
		this.currentRow=val;
	},
	//分页
	handleSizeChange(val){	
		this.pageParam.pageSize=val;
		this.getFiles();
	},
	pageHandleCurrentChange(val){
		this.pageParam.pageNum=val;
		this.getFiles();
	},
	del(){
		if(this.currentRow!=null){
			MessageBox.confirm("确定要删除 “"+this.currentRow.fileName+"” ?","确认",{
			  distinguishCancelAndClose: true,
			  confirmButtonText: '确定',
			  cancelButtonText: '取消',
			  type: 'warning',
			  offset:window.screen.height/2-100
			}).then(()=>{
			    this.$axios.post(this.$serverUrl+"/file/del",{fileId:this.currentRow.fileId}).then(
					response => {			
					  if(response.data.state==200){
						this.getFiles();
					  }else{
						Message(
						{
						 type: "error",
						 message: response.data.msg,
						 offset:window.screen.height/2-100
						});
					  }
					}
				).catch(			
					error=>{
						if(error.response.data.state===500){	
						Message(
						{
						 type: "error",
						 message: "系统出错了。",
						 offset:window.screen.height/2-100
						});
						}
				})
			});
		}
	},
	changeType(){
		if(this.currentRow!=null){
			
			this.$axios.get(this.$serverUrl+"/file/drawingType").then(
				response => {
				  if(response.data.state==200){
					this.showModal3=true;
					this.types=response.data.data;
					this.fileTypeId=this.currentRow.typeId;
				  }else{
					Message(
					{
					 type: "error",
					 message: response.data.msg,
					 offset:window.screen.height/2-100
					});
				  }
				}
			)			
			
		}else{
			Message(
			{
			 type: "error",
			 message: "请选择文件",
			 offset:window.screen.height/2-100
			});
		}
	},
	submitChangeType(){
		//console.log(this.currentRow);
		this.$axios.post(this.$serverUrl+"/file/changeDrawingType",{fileId:this.currentRow.fileId,typeId:this.fileTypeId}).then(
			response => {			
			  if(response.data.state==200){
				this.showModal3=false;
				this.getFiles();
			  }else{
				Message(
				{
				 type: "error",
				 message: response.data.msg,
				 offset:window.screen.height/2-100
				});
			  }
			}
		).catch(			
			error=>{
				if(error.response.data.state===500){	
				Message(
				{
				 type: "error",
				 message: "系统出错了。",
				 offset:window.screen.height/2-100
				});
				}
		})
	},
	getLink(val){
		return this.$serverUrl+"/file/download?fileId="+val.fileId;
	},
	//图纸分类
	handleClose(tag) {
		MessageBox.confirm("确定要删除 “"+tag.typeName+"” ?","确认",{
			distinguishCancelAndClose: true,
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
			offset:window.screen.height/2-100
		}).then(()=>{
			this.types.splice(this.types.indexOf(tag), 1);
			this.$axios.post(this.$serverUrl+"/file/delDrawingType",tag).then(
				response => {			
				  if(response.data.state!=200){
					Message(
					{
					 type: "error",
					 message: response.data.msg,
					 offset:window.screen.height/2-100
					});
				  }
				}
			).catch(	
				error=>{
					if(error.response.data.state===500){	
					Message(
					{
					 type: "error",
					 message: "系统出错了。",
					 offset:window.screen.height/2-100
					});
					}
			})
		});
	},
	showInput(){
		this.inputVisible = true;
		this.$nextTick(_ => {
		this.$refs.saveTagInput.$refs.input.focus();
		});
	},
	handleInputConfirm() {
		let inputValue = this.inputValue;
		this.$axios.post(this.$serverUrl+"/file/addDrawingType",{typeName:inputValue}).then(
			response => {			
			  if(response.data.state==200){
				this.inputVisible = false;
				this.inputValue = '';
				this.get3DType();
			  }
			}
		).catch(	
			error=>{
				if(error.response.data.state===500){	
				Message(
				{
				 type: "error",
				 message: "系统出错了。",
				 offset:window.screen.height/2-100
				});
				}
		})
	},
	get3DType(){
		this.$axios.get(this.$serverUrl+"/file/drawingType").then(
			response => {			
			  if(response.data.state==200){
				  this.types=[];
				  this.types=response.data.data;
			  }else{
				Message(
				{
				 type: "error",
				 message: response.data.msg,
				 offset:window.screen.height/2-100
				});
			  }
			}
		).catch(	
			error=>{
				if(error.response.data.state===500){	
				Message(
				{
				 type: "error",
				 message: "系统出错了。",
				 offset:window.screen.height/2-100
				});
				}
		})
	},
  }
};
</script>
<style>
	.el-table::before {
	    height: 0px;
	}
</style>
